import { Component } from '@angular/core';

@Component({
  selector: 'header-component',
  templateUrl: './header.component.html',
//   styleUrls: ['./home.component.css']
})
export class HeaderComponent {
//   title = 'home';
}